// extracted by mini-css-extract-plugin
export var cardLayout = "_a7-1";
export var paginationContainer = "_a7-0";